<template>
  <el-form-item>
    <el-collapse value="1">
      <el-collapse-item title="Available macros" name="1">
        <!-- eslint-disable-next-line vue/no-template-key -->
        <div v-for="(k, v) of macros" :key="`${v}_span`">
          <span
            ><b>%{{ v }}%</b> - {{ k }}.</span
          >
          <br />
        </div>
        <p>
          Example: https://www.mysite.com/go.engine?domain=%REFDOMAIN%&
          currentURL=%REF%&source=%SPOTID%&click_tracker=%ID%&node_id=%NODE_ID%
        </p>
        <small
          >*These macros are necessary in case of using Tracking Pixel or
          Postback url</small
        >
      </el-collapse-item>
    </el-collapse>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MacrosInfo',
  setup(_props, context) {
    const macros = {
      REF: 'Full page URL where ads were shown',
      KW: 'Keywords from the website page',
      REFDOMAIN: 'Top domain where ads were shown',
      ORIGINALREF: 'Top domain where ads was asked',
      SPOTID: 'ID of the spot that displayed your ad',
      ID: 'Traforama Click ID of the visitor session',
      NODEID: 'ID of a server node that processed the request',
      AUCTIONPRICE: 'CPM paid for the particular ad',
      CPVPRICE: 'CPV (for CPM price model)',
      CPC: 'CPC (for CPC price model)',
      CAMPAIGNID: 'Traforama Campaign ID',
      CREATIVEID: 'Traforama Creative ID',
      IP: "Visitor's IPv4 address",
      UA: "Visitor's User-Agent"
    }

    return { macros }
  }
})
</script>
